import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { NavigationTabBottom } from '../../layouts/footers/NavigationTabBottom';
import { NavbarComponent } from '../../layouts/headers/NavbarComponent';
import CategoriesSwiper from '../../components/badges/CategoriesSwiper';
import { WeatherVisualizerComponent } from '../../components/weather/WeatherVisualizerComponent';
import { ChatComponent } from '../../components/chat/ChatComponent';
import { UIThemeInterface } from '../../core/interfaces/UIThemeInterface';
import { paths } from '../../core/types/paths';
import SectionsListComponent from './SectionsListComponent';
import { setCurrentPage } from '../../core/actions/appActions';
import './Style.css';
import withScrollHandler from '../../hoc/withScrollHandler';

const MainPage: React.FunctionComponent<any> = ({ scrollpos, handleScroll }) => {

    const dispatch = useDispatch();

    // eslint-disable-next-line
    const [toggleChat, setToggleChat] = useState('inactive');

    const navigate = useNavigate();

    const uiData: UIThemeInterface = useSelector((state: any) => state.ui);

    const handleToggleChat = () => {
        setToggleChat(toggleChat === 'inactive' ? 'active' : 'inactive');
    };

    const handleCategory = (category: any) => {

        dispatch(setCurrentPage(category));

        navigate(paths[category.id]);
    }

    const onScrollMainPage = (e) => {
        handleScroll(e);
    }

    return (
        <div>
            <NavbarComponent logo={uiData.logoURL} />

            <div className='w-full pl-2 pr-2 pb-24 max-w-screen-sm m-auto main-content bg_page_top'
                style={{ 'borderRadius': '30px 30px 0px 0px', background: uiData.backgroundColor, height: `calc(100% - ${scrollpos}px)` }}
                onScroll={onScrollMainPage}>

                <div className='sticky-slider' style={{background: uiData.backgroundColor}}>
                    <CategoriesSwiper categories={uiData.menu} select={handleCategory} bgcolor={uiData.btnPrimaryColor} textcolor={uiData.textSecundaryColor} />
                </div>

                <div className='title_lg ml-2 mt-4 mb-4'>¡Bienvenido!</div>

                <WeatherVisualizerComponent uiData={uiData} />

                <SectionsListComponent list={uiData.menu} clicksection={handleCategory} />

                {/*  <span className='tittle-section'>Servicios del Hotel</span>
                <div className='row flex flex-row flex-wrap'>

                    {
                        sections[1].map(
                            (section, i) => {
                                return (<CardInformationComponent key={i} name={section.name} bgimg={section.img} size={section.size} />)
                            }
                        )
                    }
                </div>
                <span className='tittle-section'>Información de destino</span>
                <div className='row flex flex-row flex-wrap'>

                    {
                        sections[2].map(
                            (section, i) => {
                                return (<CardInformationComponent key={i} name={section.name} bgimg={section.img} size={section.size} />)
                            }
                        )
                    }
                </div> */}

            </div>

            <NavigationTabBottom clickchat={handleToggleChat} uiData={uiData} />

            {
                toggleChat === 'active' && (
                    <ChatComponent close={handleToggleChat} show={toggleChat} />
                )
            }
        </div>
    )
}

export default withScrollHandler(MainPage, { scrollinit: 168 });